import React from 'react';
import { useSelector } from 'react-redux';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Button from 'components/DesignSystem/Button';
import { AgroOverviewLocation } from 'types/Meteorology/Agro/Overview/Dashboard';
import { exportLocationsCsv } from 'helper/Meteorology/Agro/Overview/exportCsv';
import { filterAndSortLocations } from 'helper/Meteorology/Agro/Overview/locationsTable';
import {
  selectAgroOverviewTableSearch,
  selectAgroOverviewTableSortBy,
  selectAgroOverviewTableSortDirection,
} from 'redux/reducers/meteorologyAgroOverviewDashboardReducer';

import './index.scss';

export default function ExportSheet({
  open,
  dismiss,
  locations,
}: {
  open: boolean;
  dismiss: () => void;
  locations: AgroOverviewLocation[];
}) {
  const search = useSelector(selectAgroOverviewTableSearch);
  const sortBy = useSelector(selectAgroOverviewTableSortBy);
  const sortDirection = useSelector(selectAgroOverviewTableSortDirection);

  // WYSIWYG: exporta exatamente as linhas visíveis na lista (mesma busca/ordem).
  const rows = filterAndSortLocations(locations, search, sortBy, sortDirection);

  const handleExport = () => {
    exportLocationsCsv(rows);
    dismiss();
  };

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Exportar"
      className="agro-overview-mobile-export-sheet"
    >
      <div className="agro-overview-mobile-export-body">
        <p className="agro-overview-mobile-export-hint">
          {`${rows.length} ${rows.length === 1 ? 'localidade' : 'localidades'} no relatório.`}
        </p>
        <Button
          type="primary"
          icon="download"
          disabled={rows.length === 0}
          onClick={handleExport}
        >
          Exportar relatório (CSV)
        </Button>
      </div>
    </BottomSheet>
  );
}
